import React from "react";
import { Grid, Box, Typography, CardHeader } from "@mui/material";
import BreadcrumbsComponent from "./BreadcrumbsComponentL1";

const CustomCardHeader = ({
  titleIcon,
  title,
  subTitle,
  subTitleRoute,
}) => {
  return (
    <CardHeader
      title={
        <Grid container alignItems="center" justifyContent="space-between">
          <Grid item xs={12} md="auto">
            <Box display="flex" alignItems="center">
              {titleIcon}
              <Typography
                variant="h6"
                sx={{ fontSize: { xs: "1rem", md: "1.25rem" } }}
              >
                {title}
              </Typography>
            </Box>
          </Grid>
          <Grid item xs={12} md="auto">
            <BreadcrumbsComponent
              title={title}
              subTitle={subTitle}
              subTitleRoute={subTitleRoute}
            />
          </Grid>
        </Grid>
      }
      sx={{
        backgroundColor: "#1e5d45",
        color: "white",
        padding: { xs: "8px", md: "16px" },
      }}
    />
  );
};

export default CustomCardHeader;
